var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hamburger-button"},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('components.toggle-menu')))])])}
var staticRenderFns = []

export { render, staticRenderFns }